import axios from 'axios'

const instance = axios.create({
  baseURL: process.env.VUE_APP_BACKENDURL
})

export default() => {
  return instance
}



// WEBPACK FOOTER //
// ./src/services/API.js